import React, { Component, Suspense } from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import routers from './router';
import './common/less/index.less';
import './app.less';
import NotFound from './containers/404';
import './common/js/resize';

class App extends Component {
    render() {
        if (__ENV__ === 'production') {
            // 友盟 U-APM H5/WEB 性能监测服务
            // void (function(e, t, n, a, o, i, m) {
            //     (e._um_apm_namespace = o),
            //         (e[o] =
            //             e[o] ||
            //             function() {
            //                 (e[o].q = e[o].q || []).push(arguments);
            //             }),
            //         (e[o].l = e[o].l || +new Date()),
            //         (i = t.createElement(n)),
            //         i.setAttribute('crossorigin', ''),
            //         (i.src = a),
            //         (m = t.getElementsByTagName(n)[0]),
            //         m.parentNode.insertBefore(i, m);
            // })(window, document, 'script', 'https://g.alicdn.com/jssdk/apm/2.0.10/es5/uapm.iife.js', '_apm');
            // _apm('create', {
            //     pid: __UM_PID__,
            //     pageFilter: { mode: 'ignore', rules: [] },
            //     errorFilter: { mode: 'ignore', rules: ['Script error.'] },
            // });
        }

        return (
            <div className="App">
                <Suspense fallback={<div />}>
                    <BrowserRouter>
                        <Switch>
                            {routers.map((item, key) => {
                                return <Route
                                    component={item.component}
                                    exact={item.exact}
                                    key={`${item.name}-${key}`}
                                    path={item.path}
                                />;
                            })}
                            <Route
                                path="/404"
                                component={NotFound}
                            />
                            <Redirect path="*" to="/404" />
                        </Switch>
                    </BrowserRouter>
                </Suspense>
            </div>
        );
    }
}

export default App;
